import React, { Component }     from "react";
import { Button, MenuItem, Modal, Row, Col } from "react-bootstrap";
import LoaderButton                 from "../../components/LoaderButton";
import { Colors }                   from "../../utils/Colors";
import Form                         from "react-jsonschema-form";
import { schema, uiSchema }         from "../../components/assessment/schema/PrimalMovement"
import { invokeSetAddPrimalMovementAssessment,
         invokeGetAssessmentDetail} from "../../utils/AwsInvoke";
import '../../css/assessment/PrimalMovement.css';

//const log = (type) => console.log.bind(console, type);
// FORM DOCS: https://react-jsonschema-form.readthedocs.io/en/latest/#react-jsonschema-form

const onError = (errors) => console.log("I have", errors.length, "errors to fix");

let assess_form;

export default class PrimalMovementForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: false
        }

        this.handleInputChange = this.handleInputChange.bind(this);
    }

    async componentWillMount () {
        var assessment_id = this.props.assessmentId;

        if(assessment_id != "undefined") {
            var action     = "existing";
            var client_id        = this.props.clientId;
            var assessment_id    = this.props.assessmentId;

            var screen = "getPrimalMovementAssessment";
            const results = await invokeGetAssessmentDetail(screen, action, client_id, assessment_id);

            if(results) {
                var squat    = results.data[0].squat;
                var bend     = results.data[0].bend
                var lunge    = results.data[0].lunge
                var step_up  = results.data[0].step_up
                var push     = results.data[0].push;
                var pull     = results.data[0].pull;
                var twist    = results.data[0].twist;

                this.setState({
                        squat:   squat,
                        bend:    bend,
                        lunge:   lunge,
                        step_up: step_up,
                        push:    push,
                        pull:    pull,
                        twist:   twist
                });
            }
        } else {
            //this.setUserFormData();
        }
    }

    handleSubmit = async event => {

        event.preventDefault();

        var client_id        = this.props.clientId;
        var assessment_id    = this.props.assessmentId;
        var assessment_type  = 7; // heart and blood is #4 in dropdown

        var action = "";
        if(assessment_id === "undefined") action = "new";

        var exists = this.props.checkIfMemberAndTitleTFExists();
        if(!exists) return; // if there's no member name or title then you can't submit the form

        this.setState({
            isLoading: true
        })

        var squat            = this.state.squat
        var bend             = this.state.bend
        var lunge            = this.state.lunge;
        var step_up          = this.state.step_up;
        var push             = this.state.push;
        var pull             = this.state.pull;
        var twist            = this.state.twist

        var results = await this.props.addAssessmentToDB(assessment_type);

        if(results.status === true) {
            var assessment_id = results.assessment_id;

            var results2 = await invokeSetAddPrimalMovementAssessment(action, assessment_id, client_id, squat, bend, lunge, step_up, push, pull, twist)

            if(results2.status == true)
                this.props.cancelAssessment();
        } else
            this.setState({
                isLoading: false
            })
    }

    handleInputChange(event) {
          const target = event.target;
          const value = target.type === 'checkbox' ? target.checked : target.value;
          const name = target.name;

          //console.log("name: " + name);
          //console.log("value: " + value);
          this.setState({
            [name]: value
          });
    }

    render() {

        return (
            <div className="assessmentForm" style={{textAlign:"left"}}>
                { /*}<Form style      = {{textAlign:"left", fontSize: "20px !important"}}
                      className  = "assessmentHeartAndBloodForm"
                      schema     = {schema}
                      uiSchema   = {uiSchema}
                      formData   = {this.state.userFormData}
                      onChange   = {this.onChange} ref={(form) => {assess_form = form}}
                      onSubmit   = {this.onSubmit} ref={(form) => {assess_form = form}}
                      noValidate = {true}
                >*/ }
                <form onSubmit={this.handleSubmit} className="form">
                    { /***********************************************************/ }
                    { /***********************  Notes  ***************************/ }
                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <div className="grid parqRowFullWidth primal_notes_textarea_box">
                             <div className="primal_title">
                                 Squat:
                             </div>
                             <textarea name      = "squat"
                                       className = "primal_textarea"
                                       value     = {this.state.squat}
                                       onChange  = {this.handleInputChange} />
                    </div>
                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <div className="grid parqRowFullWidth primal_notes_textarea_box">
                             <div className="primal_title">
                                 Bend:
                             </div>
                             <textarea name      = "bend"
                                       className = "primal_textarea"
                                       value     = {this.state.bend}
                                       onChange  = {this.handleInputChange} />
                    </div>
                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <div className="grid parqRowFullWidth primal_notes_textarea_box">
                             <div className="primal_title">
                                 Lunge:
                             </div>
                             <textarea name      = "lunge"
                                       className = "primal_textarea"
                                       value     = {this.state.lunge}
                                       onChange  = {this.handleInputChange} />
                    </div>
                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <div className="grid parqRowFullWidth primal_notes_textarea_box">
                             <div className="primal_title">
                                 Step-up:
                             </div>
                             <textarea name      = "step_up"
                                       className = "primal_textarea"
                                       value     = {this.state.step_up}
                                       onChange  = {this.handleInputChange} />
                    </div>

                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <div className="grid parqRowFullWidth primal_notes_textarea_box">
                             <div className="primal_title">
                                 Push:
                             </div>
                             <textarea name      = "push"
                                       className = "primal_textarea"
                                       value     = {this.state.push}
                                       onChange  = {this.handleInputChange} />
                    </div>

                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <div className="grid parqRowFullWidth primal_notes_textarea_box">
                             <div className="primal_title">
                                 Pull:
                             </div>
                             <textarea name      = "pull"
                                       className = "primal_textarea"
                                       value     = {this.state.pull}
                                       onChange  = {this.handleInputChange} />
                    </div>

                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <div className="grid parqRowFullWidth primal_notes_textarea_box">
                             <div className="primal_title">
                                 Twist:
                             </div>
                             <textarea name      = "twist"
                                       className = "primal_textarea"
                                       value     = {this.state.twist}
                                       onChange  = {this.handleInputChange} />
                    </div>
                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <div className="iconAddExercise25pxVertSpacer"></div>
                    <Row className="grid" >
                          <Col xs={6} sm={6} md={6}>
                                <span onClick = { () => this.props.cancelAssessment()}
                                    style={{display:"inline-block", paddingLeft: "20px !important", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        type    = "button"
                                        text    = "Cancel"
                                        style   = {{ fontSize:18, height:42, color:"black", backgroundColor: "#ccc"}}
                                      />
                                </span>
                          </Col>
                          <Col xs={6} sm={6} md={6}>
                                <span style={{position: "relative", left:30, display:"inline-block", width:"100%"}}>
                                      <LoaderButton
                                        block
                                        style   = {{ fontSize:18, height:42, color:"white", fontWeight: "bold", backgroundColor: Colors.ok_button_bg}}
                                        //disabled={!this.validateForm()}
                                        isLoading={this.state.isLoading}
                                        text    = "Save"
                                        type    = "submit"
                                        loadingText="Saving …"
                                      />
                                </span>
                            </Col>
                     </Row>
                 </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/assessment/PrimalMovementForm.js